/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "servicing": {
            "nested": {
              "payment_plan": {
                "nested": {
                  "models": {
                    "nested": {
                      "Cadence": {
                        "values": {
                          "C_DO_NOT_USE": 0,
                          "MONTHLY": 1,
                          "WEEKLY": 2,
                          "BIWEEKLY": 3,
                          "SEMIMONTHLY": 4
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.payment_plan?.nested?.models?.nested?.Cadence) {
  $root.addJSON(jsonData);
}

/**
 * Allowed cadences (payment frequencies) for payment plans.
 *
 * SOURCE Cadence @ squareup/capital/servicing/payment_plan/models.proto at 21:1
 */
export const Cadence = $root.lookupEnum('squareup.capital.servicing.payment_plan.models.Cadence').values;